import { autocurry, compose, curry, repeatAdditiv, rightCurry } from "./functionalTools.js";
export class TextPrinter {
}
TextPrinter.join = autocurry((glue, val, ...args) => ["string", "number"].indexOf(typeof (val)) > -1 ?
    [val].concat(args).join(glue) :
    typeof (val) === "undefined" || val === null ?
        "" :
        val.concat(args).join(glue));
TextPrinter.sentence = TextPrinter.join(" ");
TextPrinter.list = TextPrinter.join(", ");
TextPrinter.joinarguments = (str, array, glue = "\n") => [str].concat(array).join(glue);
TextPrinter.append = autocurry((suffix, str) => (str ? str : "") + suffix);
TextPrinter.prepend = autocurry((prefix, str) => prefix + (str ? str : ""));
TextPrinter.brace = autocurry((str, pre, post) => pre + str + post);
TextPrinter.roundbracket = rightCurry(TextPrinter.brace, "(", ")");
TextPrinter.squarebracket = rightCurry(TextPrinter.brace, "[", "]");
export class HTMLPrinter extends TextPrinter {
    static getURLParamString(paramObject) {
        const parts = [];
        for (const key in paramObject) {
            parts.push(HTMLPrinter.urlparam(key, paramObject[key]));
        }
        return "?" + parts.join("&");
    }
}
HTMLPrinter.argumentJoiner = (glue, func) => compose(func, HTMLPrinter.join(glue));
HTMLPrinter.argsToLineConverter = curry(HTMLPrinter.argumentJoiner, " ");
HTMLPrinter.argsToBlockConverter = curry(HTMLPrinter.argumentJoiner, "\n");
HTMLPrinter.encloser = (pre, post) => rightCurry(HTMLPrinter.brace, pre, post);
HTMLPrinter.asLineEncloser = (pre, post) => HTMLPrinter.argsToLineConverter(HTMLPrinter.encloser(pre, post));
HTMLPrinter.asBlockEncloser = (pre, post) => HTMLPrinter.argsToBlockConverter(HTMLPrinter.encloser(pre, post));
HTMLPrinter.getWords = x => x.split(" ");
HTMLPrinter.firstWordProvider = x => HTMLPrinter.getWords(x)[0];
HTMLPrinter.collection = HTMLPrinter.join("\n");
HTMLPrinter.readonly = "readonly";
HTMLPrinter.prop = autocurry((propname, value, ...restargs) => [propname, HTMLPrinter.quote([value, ...restargs].join(" ").trim())].join("="));
HTMLPrinter.style = (value, ...restargs) => ["style", HTMLPrinter.quote([value, ...restargs].join("; ").trim())].join("=");
HTMLPrinter.CSSprop = autocurry((propname, value, ...restargs) => [propname, [value, ...restargs].join(" ").trim()].join(":"));
HTMLPrinter.quote = HTMLPrinter.encloser("\"", "\"");
HTMLPrinter.quoteSingle = HTMLPrinter.encloser("'", "'");
HTMLPrinter.cssClass = HTMLPrinter.prop("class");
HTMLPrinter.toolTip = HTMLPrinter.prop("title");
HTMLPrinter.type = HTMLPrinter.prop("type");
HTMLPrinter.id = HTMLPrinter.prop("id");
HTMLPrinter.propName = HTMLPrinter.prop("name");
HTMLPrinter.value = HTMLPrinter.prop("value");
HTMLPrinter.for = HTMLPrinter.prop("for");
HTMLPrinter.href = HTMLPrinter.prop("href");
HTMLPrinter.emptyhref = HTMLPrinter.href("#");
HTMLPrinter.src = HTMLPrinter.prop("src");
HTMLPrinter.alt = HTMLPrinter.prop("alt");
HTMLPrinter.step = HTMLPrinter.prop("step");
HTMLPrinter.width = HTMLPrinter.prop("width");
HTMLPrinter.size = HTMLPrinter.prop("size");
HTMLPrinter.rel = HTMLPrinter.prop("rel");
HTMLPrinter.px = HTMLPrinter.append("px");
HTMLPrinter.colspan = HTMLPrinter.prop("colspan");
HTMLPrinter.target = HTMLPrinter.prop("target");
HTMLPrinter.targetNewTag = HTMLPrinter.target("_blank");
HTMLPrinter.ondblclick = HTMLPrinter.prop("ondblclick");
HTMLPrinter.onclick = HTMLPrinter.prop("onclick");
HTMLPrinter.dataProp = compose(HTMLPrinter.prop, HTMLPrinter.prepend("data-"));
HTMLPrinter.addSemicolon = HTMLPrinter.append(";");
HTMLPrinter.classSelector = HTMLPrinter.prepend(".");
HTMLPrinter.nthChildSelector = compose(HTMLPrinter.prepend(":nth-child"), HTMLPrinter.roundbracket);
HTMLPrinter.idSelector = HTMLPrinter.prepend("#");
HTMLPrinter.removeSpaces = compose(HTMLPrinter.join(""), HTMLPrinter.getWords);
HTMLPrinter.trim = x => x.trim();
HTMLPrinter.percent = HTMLPrinter.append("%");
HTMLPrinter.startTag = HTMLPrinter.asLineEncloser("<", ">");
HTMLPrinter.endtag = compose(HTMLPrinter.asLineEncloser("</", ">"), HTMLPrinter.firstWordProvider, HTMLPrinter.join(" "));
HTMLPrinter.selfClosingTag = autocurry(HTMLPrinter.asLineEncloser("<", "/>"));
HTMLPrinter.inputTag = curry(HTMLPrinter.startTag, "input");
HTMLPrinter.inTagWrapper = tagname => HTMLPrinter.asBlockEncloser(HTMLPrinter.startTag(tagname), HTMLPrinter.endtag(tagname));
HTMLPrinter.inTagWithPropsWrapper = compose(HTMLPrinter.inTagWrapper, HTMLPrinter.join(" "));
HTMLPrinter.tagWithPropsWrapper = x => compose(HTMLPrinter.inTagWrapper, HTMLPrinter.prepend(HTMLPrinter.append(" ", x)), HTMLPrinter.join(" "));
HTMLPrinter.labelWithProps = HTMLPrinter.tagWithPropsWrapper("label");
HTMLPrinter.label = HTMLPrinter.inTagWrapper("label");
HTMLPrinter.divWitHProps = HTMLPrinter.tagWithPropsWrapper("div");
HTMLPrinter.span = HTMLPrinter.inTagWrapper("span");
HTMLPrinter.spanWithProps = HTMLPrinter.tagWithPropsWrapper("span");
HTMLPrinter.p = HTMLPrinter.inTagWrapper("p");
HTMLPrinter.pWithProps = HTMLPrinter.tagWithPropsWrapper("p");
HTMLPrinter.a = HTMLPrinter.tagWithPropsWrapper("a");
HTMLPrinter.s = HTMLPrinter.inTagWrapper("s");
HTMLPrinter.sWithProps = HTMLPrinter.tagWithPropsWrapper("s");
HTMLPrinter.h1 = HTMLPrinter.inTagWrapper("h1");
HTMLPrinter.h2 = HTMLPrinter.inTagWrapper("h2");
HTMLPrinter.h2WithProps = HTMLPrinter.tagWithPropsWrapper("h2");
HTMLPrinter.h3 = HTMLPrinter.inTagWrapper("h3");
HTMLPrinter.strong = HTMLPrinter.inTagWrapper("strong");
HTMLPrinter.strongWithProps = HTMLPrinter.tagWithPropsWrapper("strong");
HTMLPrinter.img = curry(HTMLPrinter.selfClosingTag, "img");
HTMLPrinter.br = HTMLPrinter.selfClosingTag("br");
HTMLPrinter.tr = HTMLPrinter.inTagWrapper("tr");
HTMLPrinter.trWithProps = HTMLPrinter.tagWithPropsWrapper("tr");
HTMLPrinter.td = HTMLPrinter.inTagWrapper("td");
HTMLPrinter.tdWithProps = HTMLPrinter.tagWithPropsWrapper("td");
// public static ulWithProps = HTMLPrinter.tagWithPropsWrapper("ul");
HTMLPrinter.button = HTMLPrinter.inTagWrapper("button");
HTMLPrinter.buttonWithProps = HTMLPrinter.tagWithPropsWrapper("button");
HTMLPrinter.ul = HTMLPrinter.inTagWrapper("ul");
HTMLPrinter.ulWithProps = HTMLPrinter.tagWithPropsWrapper("ul");
HTMLPrinter.li = HTMLPrinter.inTagWrapper("li");
HTMLPrinter.select = HTMLPrinter.inTagWrapper("select");
HTMLPrinter.selectWithProps = HTMLPrinter.tagWithPropsWrapper("select");
HTMLPrinter.option = HTMLPrinter.tagWithPropsWrapper("option");
HTMLPrinter.liWithProps = HTMLPrinter.tagWithPropsWrapper("li");
HTMLPrinter.sectionWithProps = HTMLPrinter.tagWithPropsWrapper("section");
HTMLPrinter.div = compose(HTMLPrinter.inTagWithPropsWrapper, HTMLPrinter.prepend("div "));
HTMLPrinter.th = HTMLPrinter.inTagWrapper("th");
HTMLPrinter.thWithProps = HTMLPrinter.tagWithPropsWrapper("th");
HTMLPrinter.textArea = HTMLPrinter.inTagWrapper("textarea");
HTMLPrinter.textAreaWithProps = HTMLPrinter.tagWithPropsWrapper("textarea");
HTMLPrinter.loadingDots = () => HTMLPrinter.pWithProps(HTMLPrinter.cssClass("loadingdots"))(repeatAdditiv(3)(HTMLPrinter.span, "."));
HTMLPrinter.getLocale = (lang, land) => [lang, land.toUpperCase()].join("-");
HTMLPrinter.toDomElement = function (htmlString) {
    const div = document.createElement("div");
    div.innerHTML = htmlString.trim();
    return div.firstChild;
};
HTMLPrinter.escapeHTML = s => {
    return s.replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
};
HTMLPrinter.urlparam = (key, value) => HTMLPrinter.brace("=", encodeURIComponent(key), encodeURIComponent(value));
HTMLPrinter.nbsp = "&nbsp;";
HTMLPrinter.srcset = (urltimes1, urltimes1point5, urltimes2) => HTMLPrinter.prop("srcset")([urltimes1 + " 1x", urltimes1point5 + " 1.5x", urltimes2 + " 2x"].join(", "));
//# sourceMappingURL=htmlprinter.js.map